import { apiGet } from './client';

// Workbench MVP Session B — Business Impact projection.

export interface BusinessImpactSource {
  source: string;
  totalCostUsd: number;
  sessionCount: number;
  avgCostPerSessionUsd: number;
}

export interface BusinessImpactSummary {
  windowDays: number;
  windowStart: string;
  windowEnd: string;
  observedTotalCostUsd: number;
  observedSessionCount: number;
  avgCostPerSessionUsd: number;
  assumedUsersPerMonth: number;
  assumedSessionsPerUser: number;
  projectedMonthlyCostUsd: number;
  projectedCostPerUserPerMonthUsd: number;
  bySource: BusinessImpactSource[];
  generatedAt: string;
}

export const getBusinessImpactSummary = (windowDays = 7) =>
  apiGet<BusinessImpactSummary>(`/api/business-impact/summary?windowDays=${windowDays}`);
